import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default () => {
  return (
    <SvgIcon>
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 200 200">
        <path
          d="M9.4,109.4c5.2,0,9.4-4.2,9.4-9.4c0-44.8,36.4-81.3,81.3-81.3c27.4,0,52.4,13.5,67.3,35.8h-11.1c-5.2,0.2-9.3,4.5-9.1,9.6
	c0.1,5,4.1,9,9.1,9.1H190c5.2,0,9.4-4.2,9.4-9.4V30.2c-0.2-5.2-4.5-9.3-9.6-9.1c-5,0.1-9,4.1-9.1,9.1v10.5C161.9,15.3,132.4,0,100,0
	C44.9,0,0,44.9,0,100C0,105.2,4.2,109.4,9.4,109.4z M190.6,90.6c-5.2,0-9.4,4.2-9.4,9.4c0,44.8-36.4,81.3-81.2,81.3
	c-24.9,0.1-48.4-11.3-63.8-30.9h9c5.2,0,9.4-4.2,9.4-9.4s-4.2-9.4-9.4-9.4H11.5c-5.2,0-9.4,4.2-9.4,9.4v33.6
	c0.1,5.2,4.4,9.3,9.6,9.2c5-0.1,9.1-4.2,9.2-9.2v-13.5c18.9,24.6,48.1,39,79.1,38.9c55.1,0,100-44.9,100-100
	C200,94.8,195.8,90.6,190.6,90.6z"
        />
      </svg>
    </SvgIcon>
  );
};
